import useAlias from '@alias';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton } from '@mui/material';
import {
  gridDetailPanelExpandedRowsContentCacheSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import { isValidElement, memo, ReactElement } from 'react';
import { DetailPanelToggleProps } from './types';

const CustomDetailPanelToggle: React.FC<DetailPanelToggleProps> = ({
  id,
  value: isExpanded,
}): ReactElement => {
  const alias = useAlias();
  const apiRef = useGridApiContext();
  const contentCache = useGridSelector(
    apiRef,
    gridDetailPanelExpandedRowsContentCacheSelector,
  );

  const hasDetail = isValidElement(contentCache[id]);

  return (
    <IconButton
      size='small'
      tabIndex={-1}
      disabled={!hasDetail}
      aria-label={alias(isExpanded ? 'Close' : 'Open')}
    >
      <ExpandMoreIcon
        sx={(theme) => ({
          transform: `rotateZ(${isExpanded ? 180 : 0}deg)`,
          transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
          }),
        })}
        fontSize='inherit'
      />
    </IconButton>
  );
};

CustomDetailPanelToggle.displayName = 'CustomDetailPanelToggle';

export default memo(CustomDetailPanelToggle);
